import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';


export const findWorkOrderListManage = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/findWorkOrderListManage?`+params,
        method: 'GET'
    })
}

export const addWorkOrder = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/insertWorkOrder`,
        method: 'POST',
        data: data
    })
}

export const findCategoryAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/category`,
        method: 'GET'
    })
}

export const findItemsByCategory = (id) => {
    return request({
        url: `${baseUrl}/joins-work//v1/item/items/${id}`,
        method: 'GET'
    })
}
export const dsrmsUpdate = (data) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource/dsrmsUpdate`,
        method: 'PUT',
        data: data
    })
}
export const findResrouceHistory = (id) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resourceHistory/${id}`,
        method: 'GET'
    })
}
export const findUsersByUserType = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsers?`+params,
        method: 'GET'
    })
}